module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-e2082054.png";